<div class="dd-wrap">

  <div class="dd-toolbar">
    <p class="dd-note">
      Live view of every <strong>run</strong> — what each driver has done, stop by stop.
      Runs are generated on <strong>Delivery today</strong> or the Routes page; everything here
      updates by itself.
    </p>

    <div class="dd-date">
      <button mat-icon-button (click)="shiftDate(-1)" matTooltip="Previous day">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <mat-form-field appearance="outline" class="dd-date-field">
        <input matInput type="date" [(ngModel)]="date" (ngModelChange)="onDateChange()">
      </mat-form-field>
      <button mat-icon-button (click)="shiftDate(1)" matTooltip="Next day">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button mat-stroked-button (click)="goToday()" [disabled]="isToday()">Today</button>
    </div>
  </div>

  <!-- live map: drivers' last known positions, and the open run's stops in
       driving order. Positions only exist while a driver has the app open. -->
  <div class="dd-map-section">
    <div class="dd-map-head">
      <strong>Map</strong>
      <span class="dd-muted">
        {{ expandedRunId ? 'Stops of the open run, numbered in driving order' : 'Open a run below to see its stops' }}
      </span>
      <span class="dd-map-spacer"></span>
      <button mat-button (click)="toggleMap()">{{ mapOpen ? 'Hide map' : 'Show map' }}</button>
    </div>

    <div class="dd-map-body" [class.dd-map-closed]="!mapOpen">
      <div class="dd-map-wrap">
        <div #mapEl class="dd-map"></div>
        <button type="button" class="dd-base" (click)="toggleBase()">
          {{ base === 'sat' ? 'Street map' : 'Satellite' }}
        </button>
        <div class="dd-legend">
          <span><i class="dm-dot dm-driver"></i> driver</span>
          <span><i class="dm-dot dm-done"></i> done</span>
          <span><i class="dm-dot dm-active"></i> at stop</span>
          <span><i class="dm-dot dm-pending"></i> pending</span>
          <span><i class="dm-dot dm-skipped"></i> skipped</span>
        </div>
      </div>
      <p class="dd-map-hint">
        A driver's position is only sent while the app is open on their screen — a marker is
        where they were <strong>last seen</strong>, and turns grey after 15 minutes.
      </p>
      <p class="dd-map-warn" *ngIf="missingPinLabel">{{ missingPinLabel }}</p>
      <p class="dd-map-warn" *ngIf="missingDriverLabel">{{ missingDriverLabel }}</p>
    </div>
  </div>

  <div class="dd-empty" *ngIf="loading">Loading runs…</div>

  <div class="dd-empty" *ngIf="!loading && !runs.length">
    No runs for {{ date }}. Generate one on <strong>Delivery today</strong> or the Routes page.
  </div>

  <div class="dd-run" *ngFor="let r of runs; trackBy: trackByRun">

    <div class="dd-run-head" (click)="toggleRun(r)">
      <div class="dd-run-main">
        <span class="dd-run-name">{{ r.routeName }}</span>
        <span class="dd-chip" [ngClass]="'dd-chip-' + r.statusClass">{{ r.statusLabel }}</span>
        <span class="dd-chip dd-chip-bad" *ngIf="r.issueCount">
          {{ r.issueCount }} issue{{ r.issueCount === 1 ? '' : 's' }}
        </span>
      </div>
      <div class="dd-run-sub">
        <span>{{ r.driverName }}</span>
        <span class="dd-covering" *ngIf="r.coveringLabel"> · {{ r.coveringLabel }}</span>
        <span *ngIf="r.expectedLabel"> · {{ r.expectedLabel }}</span>
        <span *ngIf="r.pickedUpAt"> · loaded {{ r.pickedUpAt }}</span>
        <span *ngIf="r.completedAt"> · finished {{ r.completedAt }}</span>
        <ng-container *ngIf="r.driverUid && lastSeen[r.driverUid] as seen">
          · <a class="dd-seen" [class.dd-seen-stale]="seen.stale" [href]="seen.mapsUrl"
               target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ seen.label }}</a>
        </ng-container>
      </div>
      <div class="dd-where" *ngIf="r.whereLabel">
        {{ r.whereLabel }}<span *ngIf="r.lastActivity"> · last activity {{ r.lastActivity }}</span>
      </div>
      <div class="dd-progress">
        <div class="dd-progress-bar">
          <div class="dd-progress-fill" [style.width.%]="r.progressPct"></div>
        </div>
        <span class="dd-progress-label">{{ r.completedStopCount }} / {{ r.stopCount }}</span>
        <mat-icon class="dd-caret">{{ expandedRunId === r.id ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </div>

    <div class="dd-stops" *ngIf="expandedRunId === r.id">
      <div class="dd-empty" *ngIf="stopsLoading">Loading stops…</div>

      <table class="dd-table" *ngIf="!stopsLoading && stops.length">
        <thead>
          <tr>
            <th>#</th>
            <th>Kantine</th>
            <th>Status</th>
            <th>Arrived</th>
            <th>Done</th>
            <th>Counted</th>
            <th>Svinn</th>
            <th>Checks</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of stops; trackBy: trackByStop">
            <td class="dd-order">{{ s.order }}</td>
            <td>
              <div class="dd-stop-name">{{ s.systemName }}</div>
              <div class="dd-muted" *ngIf="s.note">{{ s.note }}</div>
            </td>
            <td><span class="dd-chip" [ngClass]="'dd-chip-' + s.statusClass">{{ s.statusLabel }}</span></td>
            <td>{{ s.arrivedAt || '—' }}</td>
            <td>{{ s.completedAt || '—' }}</td>
            <td>{{ s.fillCount ? s.fillCount + ' channels' : '—' }}</td>
            <td>{{ s.svinnCount || '—' }}</td>
            <td [class.dd-bad]="s.checksBad">{{ s.checksLabel || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
